var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"m-room_add"},[_c('HotTable',{ref:"hotRef",staticStyle:{"width":"100%","overflow":"hidden","font-size":"12px"},attrs:{"settings":_vm.settings,"language":"zh-CN"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }